export default __webpack_public_path__ + "images/product/skin_types/normal_to_oily-0d9cbdf9e8ffb6635cd7b420ff0e36b1.svg";